import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import AdminUserManagement from '../components/AdminUserManagement.js';
import AdminCourseManagement from '../components/AdminCourseManagement.js';
import MonitorInviteLimitManagement from '../components/MonitorInviteLimitManagement.js';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`dashboard-tabpanel-${index}`}
      aria-labelledby={`dashboard-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 1 } }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `dashboard-tab-${index}`,
    'aria-controls': `dashboard-tabpanel-${index}`,
  };
}

const Dashboard = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Typography variant='h4' component='h1' sx={{ mb: 2 }}>
          Dashboard Administrativo
        </Typography>
        <Tabs value={value} onChange={handleChange} aria-label='dashboard tabs'>
          <Tab label='Gerenciar Usuários' {...a11yProps(0)} />
          <Tab label='Gerenciar Cursos' {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AdminUserManagement />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AdminCourseManagement />
      </TabPanel>
      {/*
      <TabPanel value={value} index={1}>
        <MonitorInviteLimitManagement />
      </TabPanel>
      */}
    </Box>
  );
};

export default Dashboard;
